<nav class="flex align-items-center w-full border-bottom-1">
  <ul class="flex flex-direction-row align-items-center w-full h-full">
    <li class="flex logo h-full border-right-1 cursor-pointer" routerLink="/">
      <div class="w-full flex align-items-center justify-content-center gap-3">
        <img
          alt="Indagoai-logo"
          [src]="
            globalStore.isDarkTheme()
              ? '../../../../assets/logo/logo.png'
              : '../../../../assets/logo/logo-dark.png'
          "
        />
      </div>
    </li>
    <li class="nav-content flex justify-content-between align-items-center w-full">
      <div class="flex">
        <div class="flex gap-2">
          <a
            *appIfFeature="FeatureFlagType.DASHBOARD_ENABLED"
            class="link no-underline border-round-sm"
            routerLink="dashboard"
            routerLinkActive="active-link"
            [routerLinkActiveOptions]="{ exact: true }"
          >
            Dashboard
          </a>
          <a
            *appIfFeature="FeatureFlagType.SALE_ENABLED"
            class="link no-underline border-round-sm"
            routerLink="sales"
            routerLinkActive="active-link"
            [routerLinkActiveOptions]="{ exact: false }"
          >
            Sales
          </a>
          <a
            *appIfHasAccess="'research_assistant'"
            class="link no-underline border-round-sm"
            routerLink="projects"
            routerLinkActive="active-link"
            [routerLinkActiveOptions]="{ exact: true }"
          >
            Projects
          </a>
          <a
            *appIfFeature="FeatureFlagType.SCHOLAR_ENABLED"
            class="link no-underline border-round-sm"
            routerLink="scholar"
            routerLinkActive="active-link"
            [routerLinkActiveOptions]="{ exact: true }"
          >
            Scholar
          </a>
          <a
            *appIfHasAccess="'vault'"
            class="link no-underline border-round-sm"
            routerLink="vault"
            routerLinkActive="active-link"
            [routerLinkActiveOptions]="{ exact: true }"
          >
            Vaults
          </a>
          <a
            *appIfHasAccess="'agents'"
            class="link no-underline border-round-sm"
            routerLink="agents"
            routerLinkActive="active-link"
            [routerLinkActiveOptions]="{ exact: false }"
            data-testid="nav-agents"
          >
            Agents
          </a>
          <a
            *appIfFeature="FeatureFlagType.TEAM_PAGE_ENABLED"
            class="link no-underline border-round-sm"
            routerLink="team"
            routerLinkActive="active-link"
            [routerLinkActiveOptions]="{ exact: true }"
          >
            Team
          </a>
        </div>
      </div>
      <div class="profile-block flex align-items-center">
        <!-- System errors placeholder -->
        <p class="error-info"></p>
        <div>
          <span class="mvp-tag">v. 3.0.0</span>
        </div>
        <div class="flex flex-row align-items-center justify-content-center gap-4">
          <div
            *appIfFeature="FeatureFlagType.THEME_ENABLED"
            class="relative theme-icon-block flex justify-content-center align-items-center"
          >
            @if (globalStore.isDarkTheme()) {
              <i class="theme-icon pi pi-sun text-lg cursor-pointer" (click)="setLightTheme()"></i>
            } @else {
              <i class="theme-icon pi pi-moon cursor-pointer" (click)="setDarkTheme()"></i>
            }
          </div>
          <div
            *appIfFeature="FeatureFlagType.GLOBAL_NOTIFICATION_ENABLED"
            class="cursor-pointer disabled"
          >
            <i class="pi pi-bell"></i>
          </div>
          <div class="flex gap-3 align-items-center cursor-pointer" (click)="menu.toggle($event)">
            <div class="w-full p-1 border-circle flex">
              <inpla-user-icon [initials]="globalStore.getUserInitials()" />
              <p-menu
                #menu
                appendTo="body"
                styleClass="account-menu"
                [model]="menuItems"
                [popup]="true"
              >
                <ng-template #start>
                  <div class="header flex align-items-center gap-3">
                    <inpla-user-icon [initials]="globalStore.getUserInitials()" />
                    <div class="flex flex-column gap-1">
                      <h4 class="text-lg">{{ globalStore.getUsername() }}</h4>
                      <h6
                        class="text-truncate email text-sm"
                        tooltipPosition="bottom"
                        [pTooltip]="
                          globalStore.getUserEmail().length >= 25 && globalStore.getUserEmail()
                        "
                      >
                        {{ globalStore.getUserEmail() }}
                      </h6>
                    </div>
                  </div>
                </ng-template>
                <ng-template #item let-item>
                  <a pRipple class="link h-full flex align-items-center p-menu-item-link">
                    <span [class]="item.icon"></span>
                    <span class="ml-2 text-sm">{{ item.label }}</span>
                  </a>
                </ng-template>
              </p-menu>
            </div>
          </div>
        </div>
      </div>
    </li>
  </ul>
</nav>
